<template>
  <md-card>
    <md-card-content>
      <md-field>
        <label>Target</label>
        <md-select v-model="filters.targets" multiple required>
          <md-option v-for="option in options.targets" :key="option" :value="option">
            {{ option }}
          </md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Target type</label>
        <md-select v-model="filters.target_type" required>
          <md-option value="ROOM">ROOM</md-option>
          <md-option v-if="hotel_settings && hotel_settings.settings_dto.algorithm_per_board" value="BOARD">BOARD</md-option>
        </md-select>
      </md-field>

      <room-type-category-select
        v-if="filters.target_type == 'ROOM' && hotel_settings && hotel_settings.settings_dto.algorithm_per_room"
        required
        v-model="filters.room_type_category_id"
      ></room-type-category-select>

      <board-select v-if="filters.target_type == 'BOARD'" required v-model="filters.board_id"></board-select>

      <year-season-select required v-model="filters.year_season_id"></year-season-select>

      <md-radio v-model="filters.travel_aggregation_type" value="STAY_DAY" required>Info per day</md-radio>
      <md-radio required v-model="filters.travel_aggregation_type" value="TRAVEL_SEASON_AND_DEMAND_TYPE"
        >Info per travel season and week</md-radio
      >
    </md-card-content>
    <md-card-actions>
      <md-button @click="$emit('applyFilters', filters)" v-if="requiredFiltersFilled">Generate table</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import HotelSettingsApi from '../../../../../openapi/src/api/HotelSettingsApi.js'
import Target from '../../../../../openapi/src/model/Target.js'

import YearSeasonSelect from '../../../../../components/Inputs/YearSeasonSelect.vue'
import RoomTypeCategorySelect from '../../../../../components/Inputs/RoomTypeCategorySelect.vue'
import BoardSelect from '../../../../../components/Inputs/BoardSelect.vue'

export default {
  name: 'TargetFilters',
  components: {
    BoardSelect,
    RoomTypeCategorySelect,
    YearSeasonSelect,
  },
  computed: {
    requiredFiltersFilled() {
      return (
        this.filters.year_season_id &&
        this.filters.targets.length &&
        this.filters.target_type &&
        this.filters.travel_aggregation_type &&
        ((this.filters.target_type == 'BOARD' && this.filters.board_id) ||
          (this.filters.target_type == 'ROOM' &&
            (!this.hotel_settings.settings_dto.algorithm_per_room || this.filters.room_type_category_id)))
      )
    },
  },
  data() {
    return {
      hotel_settings: null,
      options: {
        targets: new Target(),
      },
      filters: {
        room_target_types: [],
        season_ids: [],
        year_season_id: null,
        target_type: null,
        travel_aggregation_type: null,
      },
    }
  },
  created() {
    new HotelSettingsApi().getHotelSettings(this.$root.hotelId, (error, data) => {
      if (!error) {
        this.hotel_settings = data
      }
    })
  },
}
</script>
